<template>
    <div class="bg-dr-white py-5">
        <div class="container">
            <h2 class="fs-36 ff-dsb text-primary text-center mb-5">Our Latest Vehicles Listings</h2>
            <div class="d-flex flex-wrap gap-3 my-5">
                <div class="hstack gap-3 bg-mercury p-2 rounded-4 ms-auto overflow-x-auto">
                    <Link class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" :class="{ 'btn-toggle': $page.props.type === 'car-for-sale' || $page.props.type === null }" :href="route('index', route().params)" :data="{ vehicles: 'car-for-sale' }" :only="['vehicles', 'type']" preserve-scroll preserve-state replace>Car For Sale</Link>
                    <Link v-if="!$page.props.user?.is_agent" class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" :class="{ 'btn-toggle': $page.props.type === 'car-for-lease-and-go'}" :href="route('index', route().params)" :data="{ vehicles: 'car-for-lease-and-go' }" :only="['vehicles', 'type']" preserve-scroll preserve-state replace>Car For Lease & Go</Link>
                    <Link v-if="!$page.props.user?.is_agent" class="btn hover-apocalyptic-orange ff-dsb rounded-3 px-sm-4 px-3 text-nowrap" :class="{ 'btn-toggle': $page.props.type === 'car-for-rent' }" :href="route('index', route().params)" :data="{ vehicles: 'car-for-rent' }" :only="['vehicles', 'type']" preserve-scroll preserve-state replace>Car For Rent</Link>
                </div>
                <Link :href="route('front.vehicles.index')" class="fs-15 text-primary ff-dsm ms-auto mt-auto">
                    View All <ButtonArrowIcon class="fill-primary"/>
                </Link>
            </div>
            <div class="vehicle-swiper-wrap" v-if="$page.props.vehicles.length">
                <swiper-container :slides-per-view="1" :navigation-next-el="'.vehicle-swiper-wrap .swiper-next'" :navigation-prev-el="'.vehicle-swiper-wrap .swiper-prev'">
                    <swiper-slide v-for="vehicleChunks in $filters.chunk($page.props.vehicles, 4)">
                        <div class="row row-cols-xl-2 row-cols-1 g-4">
                            <div class="col" v-for="vehicle in vehicleChunks">
                                <VehicleCard :vehicle="vehicle"/>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper-container>
                <div class="mt-5 hstack gap-3 justify-content-center">
                    <div class="border bg-white rounded-4 px-4 py-2 fs-12 swiper-prev"><i class="far fa-chevron-left"></i></div>
                    <div class="border bg-white rounded-4 px-4 py-2 fs-12 swiper-next"><i class="far fa-chevron-right"></i></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import { register } from 'swiper/element/bundle';
import VehicleCard from './VehicleCard.vue';
import ButtonArrowIcon from './icons/ButtonArrowIcon.vue';

register();
</script>
